import { lazy } from "react";
import { RouteObject } from "react-router-dom";

import { RouterGuard } from "../guard";

const IndexPage = lazy(() => import("@/pages/index-page"));

const indexPage: RouteObject = {
  path: "/index-page",
  element: <RouterGuard element={<IndexPage />} />,
  children: [],
};

export default indexPage;
